import { Stack, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { DoneAll } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Countries } from '../../../../../shared/enums';

export interface CountryIndicatorProps {
  countryStatus: {
    country: keyof typeof Countries;
    status: string;
  };
}

function CountryStatus({ countryStatus }: CountryIndicatorProps) {
  return (
    <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
      <Typography>{Countries[countryStatus.country]}:</Typography>
      {countryStatus.status === null && <Typography>N/A</Typography>}
      {countryStatus.status === 'reserved' && (
        <DoneAll sx={{ color: '#388C2D' }} />
      )}
      {countryStatus.status === 'partially-reserved' && (
        <DoneIcon sx={{ color: '#FD8200' }} />
      )}
      {countryStatus.status !== 'reserved' &&
        countryStatus.status !== 'partially-reserved' &&
        countryStatus.status !== null && (
          <CloseIcon sx={{ color: '#F00F00' }} />
        )}
    </Stack>
  );
}

export default CountryStatus;
